import Squircle from './components/Squircle';
export * from './types/types';

export default Squircle;
